import { link } from "@/components/Action.tsx";
import type { ManagedServiceLoc } from "@/modules/services/servicesQuery.ts";

export function serviceLink({ uuid, location }: ManagedServiceLoc) {
    return link({ to: "/services/service/$location/$serviceId", params: { location, serviceId: uuid } });
}
